<template>
  <div class="u-wrap">
    <div class="u-menu-wrap" >
        <van-empty v-if="!loading&&dataList.length == 0" description="暂无数据" />
       <van-pull-refresh v-else v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading"  offset="20" :finished="finished" :finished-text="finishedTxt" @load="onLoad">
            <div style="width:100vw;">
              <div class="news-card" v-for="(item, index) in dataList" :key="index" @click="goDetail(item)">
                <div v-if="item.dqzt=='01'" class="state bg-yellow" >待处理</div>
                <div v-else-if="item.dqzt=='02'" class="state bg-blue" >处理中</div>
                <div v-else-if="item.dqzt=='03'||item.dqzt=='04'" class="state bg-green" >已办结</div>
                <span class="theme u-line-2" style="margin-right:60px">{{item.nr}} </span>
                <div class="time">{{item.createTime}}</div>
            </div>
          </div> 
        </van-list>
      </van-pull-refresh>
    </div>
    <div class="sb-btn" @click="clickSb">上报</div>
  </div>
</template>

<script>
import { getAction, postAction ,postParam } from '@/api/manage'
import Vue from 'vue'
export default {
  data() {
    return {
      current: 0, // 预设当前项的值
      keyword: '',
      dataList: [],
      loading: false,
      finished: false,
      refreshing: false,
      type:'10',
      pageNo:0,
      finishedTxt:''
    }
  },
  created(){
    this.onRefresh();
  },
  computed: {},
  methods: {
    getData() {
      let params = {type:this.type,pageNo:this.pageNo};
      getAction('/zhshj/sbdwmx/page/qzsb',params)
      .then((res) => {
           if (this.refreshing) {
              this.dataList = [];
              this.refreshing = false;
          }
        let list = res.result.records;
        this.dataList = this.dataList.concat(list);
         this.loading = false;
        if(res.result.pages <= this.pageNo){
           this.finished = true;
           if(this.pageNo!=1){
              this.finishedTxt = "暂无更多了"
            }
        }
      })
    },
      onLoad() {
        this.pageNo++
        this.getData();
   
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.finishedTxt = '';
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.pageNo = 0;
      this.refreshing  = true;
      this.onLoad();
    },
    goDetail(item){
      this.$router.push({
        path:'/gzfw/sbdwmx-view',
        query:{id:item.id},
      });
    },
    clickSb(){
     this.$router.push({
        path:'/gzfw/sbdwmx-add'
      }); 
    }

  },
}
</script>

<style lang="less" scoped>
// @import '../../assets/less/whon-theme.less';
.u-wrap {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

	.u-menu-wrap {
		flex: 1;
	}


.u-search {
  padding: 6px 12px;
  display: flex;
  align-items: center;
  background-color: #eeeeef;
}

.u-btn {
  background-color: #3e78f7;
  color: #fff;
  font-size: 14px;
  padding: 2px 12px;
  line-height: 26px;
  margin-left: 12px;
  border-radius: 4px;
}

.input {
  flex: 1;
  height: 30px;
  line-height: 30px;
  border: 1px solid #ededed;
  padding-left: 8px;
  font-size: 14px;
}

::v-deep .van-pull-refresh {
   min-height:100%
}

.news-card {
  height: auto;
  background: #ffffff;
  border-bottom: 1px solid #eee;
  display: flex;
  padding: 12px 10px;
  position: relative;
  display: flex;
  flex-direction: column;



  .theme {
    font-size: 14px;
    font-weight: 500;
    color: #303133;
  }


  .time {
    font-size: 13px;
    font-weight: 400;
    color: #999999;
    margin-top: 10px;
  }

  .state {
    position: absolute;
    right: 0;
    top: 14px;
    width: 66px;
    height: 20px;
    text-align: center;
    border-right: none;
    border-radius: 15px 0 0 15px;
    font-size: 13px;
  }
}

.sb-btn{
  position: fixed;
  width: 50px;
  height: 50px;
  line-height: 50px;
  border-radius: 50px;
  background: #3e78f7;
  color: #FFF;
  text-align: center;
  box-shadow: 0 0 4px rgba(0,0,0,0.3);
  bottom: 80px;
  right: 30px;
}

 .bg-blue {
     background: #C1DBFF;
     border: 1px solid #1D6DDB;
     color: #1D6DDB;
   }
   .bg-yellow {
     color: #DB891D;
     background: #FFE6C1;
     border: 1px solid #DB961D;
   }
   .bg-green {
     background: #C1FFD6;
     border: 1px solid #1DDB80;
     color: #16BE70;
   }
</style>
